var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"json-editor"},[_c('json',{attrs:{"isEditable":""}},[_c('keep-alive',[_c(_vm.editor,{ref:"json-editor",tag:"component",attrs:{"dynamic":""}})],1)],1),_vm._v(" "),_vm._t("read-only")],2)}
var staticRenderFns = []

export { render, staticRenderFns }